module.exports = __webpack_public_path__ + "img/storage-2.16689f4f.jpg";